export default "__VITE_ASSET__CpMdQF1y__"